export default __webpack_public_path__ + "static/media/sold_single_visited.585dc99c.svg";